import LegalPage from "./LegalPage";

export default function Privacy() {
  return <LegalPage testId="privacy-page" path="/privacy-policy" page="privacy" />;
}
